const pageTypes = {
  search_results: /^.+\/shop\/search\/(\w+\/)?(flights|hotels)?\?.*(id=\w+-\w+-\w+-\w+-\w+).+$/,
  product_details: /^.+\/shop\/search\/(\w+\/)?(hotels|flights)\/.+$/,
  checkout_process: /^.+(\/cart\/checkout\/|\/shop\/search\/\w+\/itinerary).+$/,
  post_booking: /^.+\/travel-itinerary.+$/,
  index: /^.+\/shop\/search(\/\w+)?\/?.*$/,
  landing: /^.+\/vacationpackages(\/\w+)?\/?.*$/,
  others: /^.+$/
}

export const getType = pageType => {
  switch (pageType) {
    case 'index':
    case 'landing':
      return 'landing'
    case 'search_results':
      return 'search'
    case 'product_details':
      return 'details'
    case 'checkout_process':
    case 'post_booking':
      return 'book'
    default:
      return 'other'
  }
}

export const getPageType = url => {
  return Object.keys(pageTypes).find(type => pageTypes[type].test(url))
}
